const moneyFormatter = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const currencyFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  currencyDisplay: "narrowSymbol",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const percentFormatter = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const issueSizeFormatter = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatIndianMoney = (value: number) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "0.00";
  }

  return moneyFormatter.format(numeric);
};

export const formatCurrencyInr = (value: number) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return currencyFormatter.format(0);
  }

  return currencyFormatter.format(numeric);
};

export const formatInr = (value: number) => formatCurrencyInr(value);

export const formatSignedInr = (value: number, showPlusForPositive = true) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return showPlusForPositive ? `+${formatCurrencyInr(0)}` : formatCurrencyInr(0);
  }

  const sign = numeric < 0 ? "-" : showPlusForPositive ? "+" : "";
  return `${sign}${formatCurrencyInr(Math.abs(numeric))}`;
};

export const formatPercent = (value: number) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "0.00";
  }

  return percentFormatter.format(numeric);
};

export const formatIssueSizeCr = (value: string | number | null | undefined) => {
  const raw = String(value ?? "").trim();
  if (!raw) {
    return "-";
  }

  const normalizedNumeric = raw
    .replace(/[₹,\s]/g, "")
    .replace(/rs\.?/gi, "")
    .replace(/inr/gi, "")
    .replace(/crores?/gi, "")
    .replace(/\bcr\b/gi, "");
  const numeric = Number(normalizedNumeric);

  if (Number.isFinite(numeric)) {
    return `₹${issueSizeFormatter.format(numeric)} cr`;
  }

  return raw.replace(/\s+/g, " ");
};
